import React from "react";
import PropTypes from "prop-types";
import {
  FormattedMessage,
  injectIntl,
  Link,
  IntlContextConsumer,
} from "gatsby-plugin-intl";
import { Button, Container, Menu, Icon, Image } from "semantic-ui-react";
import LanguageSelect from "./LanguageSelect";
import HardLink from "./HardLink";
import logo from "../assets/logo.png";

const NavBar = ({ fixed, landing, toggle, onToggleClick, intl }) => {
  return (
    <IntlContextConsumer>
      {({ originalPath: activeItem }) => (
        <Menu
          fixed={fixed ? "top" : null}
          attached={!fixed ? "top" : null}
          inverted={!fixed}
          pointing={!fixed}
          secondary={!fixed}
          size="large"
          borderless
          style={{ height: 50 }}
        >
          <Container>
            {toggle && (
              <Menu.Item onClick={onToggleClick}>
                <Icon name="sidebar" />
              </Menu.Item>
            )}
            {!toggle && (
              <Menu.Item
                as={Link}
                name="index"
                to="/"
                active={activeItem === "/"}
              >
                {landing ? (
                  <FormattedMessage id="nav_home" />
                ) : (
                  <>
                    <Image
                      src={logo}
                      alt="logo"
                      style={{ width: 24, marginRight: 8 }}
                    />
                    <b>{intl.locale === "ko" ? "픽픽" : "PICPICK"}</b>
                  </>
                )}
              </Menu.Item>
            )}
            {!toggle && (
              <Menu.Item
                as={Link}
                name="features"
                to="/features"
                active={activeItem === "/features/"}
              >
                <FormattedMessage id="nav_features" />
              </Menu.Item>
            )}
            {!toggle && intl.locale !== "ko" && (
              <Menu.Item
                as={Link}
                name="partners"
                to="/partners"
                active={activeItem === "/partners/"}
              >
                <FormattedMessage id="nav_partners" />
              </Menu.Item>
            )}
            {!toggle && intl.locale === "ko" && (
              <Menu.Item
                as={Link}
                name="download"
                to="/download"
                active={activeItem === "/download/"}
              >
                <FormattedMessage id="nav_download" />
              </Menu.Item>
            )}
            {!toggle && (
              <Menu.Item
                as={Link}
                name="contact"
                to="/contact"
                active={activeItem === "/contact/"}
              >
                <FormattedMessage id="nav_contact" />
              </Menu.Item>
            )}
            <Menu.Item position="right">
              {fixed && !toggle && intl.locale !== "ko" && (
                <Button
                  as={Link}
                  name="download"
                  to="/download"
                  inverted={!fixed}
                  color="blue"
                  style={{ marginRight: "0.5em" }}
                  content={intl.formatMessage({ id: "nav_download" })}
                />
              )}
              {fixed && !toggle && intl.locale !== "ko" && (
                <Button
                  as={HardLink}
                  to="/buy"
                  color="orange"
                  inverted={!fixed}
                  style={{ marginRight: "2em" }}
                  content={intl.formatMessage({ id: "nav_buy" })}
                />
              )}
              <LanguageSelect />
            </Menu.Item>
          </Container>
        </Menu>
      )}
    </IntlContextConsumer>
  );
};

NavBar.propTypes = {
  fixed: PropTypes.bool.isRequired,
  toggle: PropTypes.bool,
  onToggleClick: PropTypes.func,
};

NavBar.defaultProps = {
  toggle: false,
  onToggleClick: () => {},
};

export default injectIntl(NavBar);
